// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2uMuI","noInteraction":"EventWrapper_noInteraction__2-dWe"};